export const auth = {
errors: {
  deleteAccountFailed: "Votre compte n’a pas été supprimé. Réessayez.",
  workspacePreparing: "Votre espace de travail est encore en cours de préparation. Patientez un instant, puis réessayez.",
  signInAgain: "Reconnectez-vous pour continuer.",
  callbackCancelled: "La connexion a été annulée avant la fin. Réessayez quand vous êtes prêt.",
  signInNotFinished: "La connexion n’a pas abouti. Réessayez.",
  signupUnavailable: "Nous ne pouvons pas créer de compte pour le moment. Réessayez plus tard.",
  signupClosed: "Les nouveaux comptes se font sur invitation pour le moment. Utilisez le lien de votre e-mail d’invitation ou connectez-vous avec votre compte existant.",
  linkExpired: "Ce lien a expiré ou a déjà été utilisé. Demandez-en un nouveau.",
  emailInvalid: "Saisissez une adresse e-mail valide.",
  passwordTooCommon: "Ce mot de passe est trop facile à deviner. Choisissez-en un autre.",
  passwordNeedsMix: "Utilisez des majuscules, des minuscules, des chiffres et des symboles.",
  passwordTooShort: "Utilisez au moins {{n}} caractères.",
  samePassword: "Choisissez un mot de passe que vous n’avez jamais utilisé.",
  emailRateLimited: "Nous venons de vous envoyer un e-mail. Attendez une minute avant d’en demander un autre.",
  rateLimited: "Trop de tentatives. Attendez une minute, puis réessayez.",
  alreadyRegistered: "Cet e-mail a déjà un compte. Touchez Se connecter, ou Mot de passe oublié ? s’il vous en faut un nouveau.",
  emailNotConfirmed: "Confirmez d’abord votre e-mail. Ouvrez le lien que nous vous avons envoyé, puis connectez-vous.",
  invalidCredentials: "Cet e-mail et ce mot de passe ne correspondent pas. Vérifiez-les, puis réessayez.",
  offline: "Vous êtes hors ligne. Vérifiez votre connexion, puis réessayez.",
  generic: "Un problème est survenu. Réessayez.",
},
session: {
  signIn: "Se connecter",
  renew: "Renouveler la session",
  expiredBody: "Touchez Renouveler la session pour continuer, ou Se connecter pour recommencer.",
  expiredTitle: "Votre session a expiré",
},
appName: "AssetWRX",
social: {
  errorStartFailed: "La connexion n’a pas démarré. Réessayez.",
  errorPopupTimeout: "La fenêtre de connexion a attendu trop longtemps et s'est fermée. Touchez le bouton de connexion pour recommencer.",
  errorPopupBlocked: "Votre navigateur a bloqué la fenêtre de connexion. Autorisez les fenêtres pop-up pour cette page, puis touchez à nouveau le bouton de connexion.",
continueWith: "ou continuer avec",
google: "Continuer avec Google",
apple: "Continuer avec Apple",
microsoft: "Continuer avec Microsoft",
signingIn: "Ouverture de la connexion...",
errorSignInFailed: "La connexion n'a pas abouti. Réessayez.",
},
callback: {
  continueHere: "Continuer dans ce navigateur",
  appSignInHint: "Dans l’application, touchez Se connecter et utilisez l’e-mail et le mot de passe que vous venez de choisir.",
title: "Connexion en cours",
body: "Un instant.",
successTitle: "Vous êtes connecté",
successBody: "Ouverture d’AssetWRX…",
errorTitle: "La connexion n’a pas abouti",
error: "Ce lien a expiré ou a déjà été utilisé. Touchez Retour à la connexion et réessayez.",
backToSignIn: "Retour à la connexion",
openInApp: "Ouvrir l’application AssetWRX",
},
login: {
  biometricPasswordChanged: "Votre mot de passe a changé, {{method}} est donc désactivé. Connectez-vous avec votre nouveau mot de passe et cochez Utiliser {{method}} la prochaine fois.",
  title: "Connectez-vous à AssetWRX",
showPassword: "Afficher le mot de passe",
hidePassword: "Masquer le mot de passe",
subtitle: "Connectez-vous à votre compte",
email: "E-mail",
password: "Mot de passe",
emailPlaceholder: "vous@exemple.com",
passwordPlaceholder: "Votre mot de passe",
forgotPassword: "Mot de passe oublié ?",
signIn: "Se connecter",
signingIn: "Connexion...",
noAccount: "Pas encore de compte ?",
createAccount: "Créer un compte",
createAccountCta: "Nouveau ? Créez un compte",
orWithEmail: "ou connectez-vous par e-mail",
newHere: "Nouveau sur AssetWRX ?",
createAccountLink: "Créer un compte",
biometricUseNextTime: "Utiliser {{method}} la prochaine fois",
biometricSignIn: "Se connecter avec {{method}}",
biometricPrompt: "Connexion à AssetWRX",
biometricMethodFace: "Face ID",
biometricMethodFingerprint: "l’empreinte digitale",
biometricMethodIris: "l’iris",
biometricMethodGeneric: "la biométrie",
embedSsoHint: "Ce portail vous connecte avec le compte Microsoft de votre organisation.",
errorEmailRequired: "Veuillez saisir votre e-mail.",
errorEmailInvalid: "Saisissez une adresse e-mail valide.",
errorPasswordRequired: "Veuillez saisir votre mot de passe.",
errorLoginFailed: "La connexion n’a pas fonctionné. Vérifiez votre e-mail et votre mot de passe, puis réessayez.",
},
signup: {
  passwordHint: "Utilisez au moins {{n}} caractères.",
  useDifferentEmail: "Utiliser une autre adresse e-mail",
title: "Créer un compte",
subtitle: "Rejoignez AssetWRX — le système d’exploitation de vos actifs physiques.",
firstName: "Prénom",
firstNamePlaceholder: "Jean",
lastName: "Nom",
lastNamePlaceholder: "Dupont",
role: "Rôle",
rolePlaceholder: "Responsable des opérations",
email: "E-mail",
emailPlaceholder: "vous@exemple.com",
password: "Mot de passe",
passwordPlaceholder: "Choisissez un mot de passe robuste",
showPassword: "Afficher le mot de passe",
hidePassword: "Masquer le mot de passe",
confirmPassword: "Confirmer le mot de passe",
confirmPlaceholder: "Saisir à nouveau le mot de passe",
submit: "Créer un compte",
signingUp: "Création du compte...",
hasAccount: "Vous avez déjà un compte ?",
signInLink: "Se connecter",
emailInstead: "S’inscrire avec un e-mail",
emailInsteadHide: "Masquer l’inscription par e-mail",
useEmail: "Utiliser plutôt l’e-mail",
useEmailHide: "Masquer l’inscription par e-mail",
name: "Votre nom",
namePlaceholder: "Alex Martin",
errorNameRequired: "Veuillez saisir votre nom.",
hasAccountShort: "Vous avez déjà un compte ?",
errorFirstNameRequired: "Veuillez saisir votre prénom.",
errorLastNameRequired: "Veuillez saisir votre nom.",
errorRoleRequired: "Veuillez saisir votre rôle.",
errorEmailRequired: "Veuillez saisir votre e-mail.",
errorPasswordRequired: "Veuillez saisir un mot de passe.",
errorPasswordMismatch: "Les mots de passe ne correspondent pas.",
emailInvalid: "Saisissez une adresse e-mail valide.",
passwordsMatch: "Les mots de passe correspondent.",
passwordStrength: {
weak: "Faible",
fair: "Moyen",
good: "Bon",
strong: "Fort",
},
errorSignUpFailed: "Votre compte n’a pas été créé. Réessayez.",
errorLanguageInvalid: "Choisissez une langue prise en charge.",
errorTimezoneInvalid: "Choisissez un fuseau horaire valide.",
regionalSectionTitle: "Langue, fuseau horaire et devise",
regionalSectionBody: "Ces réglages s’appliquent à votre profil et à votre nouvel espace de travail. Vous pourrez les modifier plus tard dans les paramètres.",
languageLabel: "Langue",
timezoneLabel: "Fuseau horaire",
currencyLabel: "Devise de l’espace de travail",
currencyA11y: "Devise de l’espace de travail {{code}}",
successCheckEmail: "Compte créé. Vérifiez votre e-mail pour confirmer votre compte, puis connectez-vous.",
successEmailTitle: "Vérifiez votre boîte mail",
successEmailBody: "Nous avons envoyé un lien à {{email}}. Ouvrez-le pour terminer la création de votre compte.",
resendConfirmation: "Renvoyer le lien",
resendingConfirmation: "Envoi…",
resendSuccess: "Envoyé. Vérifiez votre boîte de réception et vos indésirables.",
resendError: "Le lien n’a pas été envoyé. Attendez une minute, puis touchez Renvoyer le lien.",
consent: {
sectionTitle: "Avant de continuer",
sectionBody: "Merci de consulter et d'accepter les documents ci-dessous. Les deux sont requis pour créer votre compte.",
acceptTerms: "J’ai lu et j’accepte les <1>Conditions d’utilisation</1>.",
acceptPrivacy: "J’ai lu et j’accepte la <1>Politique de confidentialité</1>.",
errorTermsRequired: "Veuillez accepter les Conditions d'utilisation pour continuer.",
errorPrivacyRequired: "Veuillez accepter la Politique de confidentialité pour continuer.",
a11yTermsCheckbox: "Accepter les Conditions d'utilisation",
a11yPrivacyCheckbox: "Accepter la Politique de confidentialité",
compactLead: "J’accepte :",
termsShort: "Conditions",
read: "Lire",
privacyShort: "Confidentialité",
a11yReadTerms: "Lire les Conditions d’utilisation",
a11yReadPrivacy: "Lire la Politique de confidentialité",
shareUsage: "Partager des données d’utilisation pour aider à améliorer AssetWRX (facultatif)",
byContinuingBefore: "En continuant, vous acceptez les ",
byContinuingBetween: " et la ",
byContinuingAfter: ".",
termsDoc: "Conditions d’utilisation",
privacyDoc: "Politique de confidentialité",
},
wizard: {
flowSubtitle: "Une configuration guidée rapide pour votre espace de travail",
valueStrip: "Commencez gratuitement. Sans carte bancaire.",
stepProgress: "Étape {{current}} sur {{total}}",
loadingDraft: "Restauration de votre progression…",
welcomeBody: "Créez votre compte avec Google, Apple, Microsoft ou par e-mail. Les nouveaux comptes passent par une courte configuration après la connexion.",
continueWithEmail: "Continuer avec l'e-mail",
back: "Retour",
next: "Suivant",
yes: "Oui",
no: "Non",
errorUseCaseRequired: "Veuillez choisir comment vous prévoyez d'utiliser AssetWRX.",
errorWorkspaceNameRequired: "Veuillez saisir un nom d'espace de travail.",
errorStarterRequired: "Choisissez ce que vous voulez faire en premier.",
useCaseTitle: "Usage principal",
useCaseBody: "Choisissez l'option qui vous correspond le mieux. Vous pourrez l'affiner plus tard.",
useCases: {
field_inspections: "Inspecter des lieux ou des équipements",
asset_register: "Tenir la liste de ce que nous gérons",
jobs_workorders: "Organiser les réparations et les interventions",
team_collab: "Travailler avec mon équipe",
compliance_reporting: "Certificats et conformité",
other: "Autre chose",
},
workspaceTitle: "Votre espace de travail",
workspaceBody: "C'est l'espace de votre organisation dans AssetWRX. Vous pourrez le renommer plus tard dans les paramètres.",
workspaceNameLabel: "Nom de l'espace de travail",
workspaceNamePlaceholder: "ex. Acme Facilities",
inviteOnlyNote: "Rejoindre l'équipe de quelqu'un d'autre se fait uniquement sur invitation (utilisez le lien de votre e-mail d'invitation).",
intentCreateTeam: "Créer une équipe dans cet espace de travail",
intentInviteMembers: "Inviter des membres de l'équipe après la configuration",
starterTitle: "Que voulez-vous faire en premier ?",
starterBody: "Nous ouvrirons la bonne zone après votre connexion et la fin de la configuration.",
starters: {
home: "Ouvrir le tableau de bord Accueil",
asset: "Ajouter un actif",
inspection: "Démarrer une inspection",
schedule: "Planifier une inspection",
team: "Gérer l'équipe et les invitations",
},
reviewTitle: "Vérifier et créer le compte",
reviewName: "Nom : {{name}}",
reviewEmail: "E-mail : {{email}}",
reviewWorkspace: "Espace de travail : {{name}}",
reviewTeam: "Créer une équipe : {{yes}}",
reviewInvites: "Inviter des membres : {{yes}}",
reviewEditHint: "Cette étape affiche seulement un résumé. Pour saisir un autre nom, e-mail ou mot de passe, utilisez le bouton ci-dessous (ou revenez en arrière pour reparcourir les étapes précédentes).",
reviewEditCta: "Modifier le nom, l'e-mail et le mot de passe",
},
},
firstRunSample: {
secondCheck: {
property: "Détecteurs de fumée présents et fonctionnels ?",
vehicle: "Feux et pneus en bon état ?",
equipment: "Protecteurs et étiquettes d’avertissement en place ?",
other: "Équipements de sécurité présents et en état de servir ?",
},
quickLook: {
templateName: "Coup d’œil rapide",
firstCheck: "État visuel acceptable ?",
},
useCases: {
field_inspections: {
assetName: "Pompe de circulation d’exemple",
assetDescription: "Un exemple que vous pouvez supprimer, pour essayer une inspection sur le terrain.",
templateName: "Contrôle de l’état de la pompe",
firstCheck: "Carter et protecteurs bien fixés ?",
secondCheck: "Fuites, bruit ou vibrations ?",
},
jobs_workorders: {
assetName: "Centrale de traitement d’air d’exemple",
assetDescription: "Un exemple que vous pouvez supprimer, pour repérer et confier du travail de maintenance.",
templateName: "Tournée d’entretien",
firstCheck: "Accès et points d’isolement dégagés ?",
secondCheck: "Une maintenance de suivi est-elle nécessaire ?",
},
compliance_reporting: {
assetName: "Équipement de sécurité incendie d’exemple",
assetDescription: "Un exemple que vous pouvez supprimer, pour essayer des contrôles de conformité fondés sur des preuves.",
templateName: "Contrôle des preuves de conformité",
firstCheck: "Identification et état confirmés ?",
secondCheck: "Preuves recueillies et à jour ?",
},
asset_register: {
assetName: "Véhicule de service d’exemple",
assetDescription: "Un exemple que vous pouvez supprimer, qui montre la fiche d’un actif en exploitation.",
templateName: "Contrôle de l’état du véhicule",
firstCheck: "État extérieur acceptable ?",
secondCheck: "Équipements de sécurité présents et en état de servir ?",
},
other: {
assetName: "Équipement d’exemple",
assetDescription: "Un exemple que vous pouvez supprimer, pour essayer une inspection et le travail de suivi.",
templateName: "Contrôle opérationnel rapide",
},
},
},
postSignupOnboarding: {
industryTitle: "Que gérez-vous ?",
industryHint: "Nous ajoutons des check-lists prêtes à l’emploi. Vous pourrez les modifier plus tard dans Check-lists.",
industryChoices: {
property: "Immobilier",
fleet: "Flotte",
equipment: "Équipements",
facilities: "Installations",
mixed: "Un mélange, ou autre chose",
},
title: "Configurez votre espace de travail",
subtitle: "Un nom, deux choix rapides, et vous êtes prêt.",
stepProgress: "Étape {{current}} sur {{total}}",
workspaceTitle: "Nom de l’espace de travail",
workspacePlaceholder: "Nom de votre organisation ou de votre équipe",
workspaceHint: "En général le nom de votre entreprise ou équipe. Vous pourrez le changer plus tard.",
useCaseTitle: "À quoi servira AssetWRX ?",
roleTitle: "Votre rôle",
teamTitle: "Équipe et invitations",
starterTitle: "Où souhaitez-vous commencer ?",
finish: "Continuer",
finishing: "Préparation…",
deferNote: "Vous pourrez changer la langue, la devise et l’équipe plus tard dans Compte.",
errorWorkspaceRequired: "Veuillez saisir un nom d’espace de travail.",
errorUseCaseRequired: "Veuillez choisir un cas d’usage principal.",
errorRoleRequired: "Veuillez choisir votre rôle.",
errorSave: "Impossible d’enregistrer. Veuillez réessayer.",
inviteNote: "Vous pourrez inviter des personnes après cette étape.",
applyingTitle: "Application de vos choix",
applyingBody: "Nous préparons votre espace de travail. Un instant.",
languageTitle: "Langue",
localeLineTitle: "Devise et langue",
localeChange: "Modifier",
localeDone: "Terminé",
languageHint: "Choisissez votre langue. Vous pourrez la changer plus tard dans Compte.",
currencyTitle: "Devise",
currencyHint: "Choisissez la devise que vous utilisez. Vous pourrez la changer plus tard dans Compte.",
},
firstActionChooser: {
title: "Par quoi voulez-vous commencer ?",
framing: "Ajoutez quelque chose que vous gérez, ou essayez une inspection d’entraînement sur un exemple.",
framingTeam: "Invitez les personnes avec qui vous travaillez, ajoutez quelque chose que vous gérez, ou essayez une inspection d’entraînement.",
asset: {
title: "Ajouter mon premier actif",
subtitle: "Un nom et un type suffisent. Complétez plus tard.",
},
sample: {
title: "Essayer une inspection d’entraînement",
subtitle: "Nous ajoutons un actif d’exemple pour vous montrer une inspection. Supprimez-le quand vous voulez.",
},
recommended: "Suggéré",
reassure: "Vous pouvez supprimer l’exemple à tout moment.",
sampleErrorFallback: "Impossible de préparer l’exemple. Vous pouvez ajouter votre propre actif à la place.",
skip: "Accéder à l’accueil",
team: {
title: "Configurez votre équipe",
subtitle: "Créez une équipe et invitez les personnes avec qui vous travaillez. Nous vous guidons à chaque étape.",
subtitleLocked: "Les équipes sont incluses dans une offre supérieure. Touchez pour voir lesquelles.",
},
},
forgot: {
  sentAgain: "Renvoyé. Vérifiez votre boîte de réception et vos indésirables.",
  spamHint: "Rien reçu ? Vérifiez vos courriers indésirables.",
  sendAgain: "Renvoyer",
title: "Mot de passe oublié ?",
subtitleEmail: "Saisissez votre e-mail et touchez Envoyer le lien. Nous vous enverrons un lien pour choisir un nouveau mot de passe.",
email: "E-mail",
emailPlaceholder: "vous@exemple.com",
sendLink: "Envoyer le lien",
sending: "Envoi...",
backToSignIn: "Retour à la connexion",
sentTitle: "Vérifiez votre e-mail",
sentBody: "Si {{email}} a un compte, nous avons envoyé un lien de réinitialisation. Ouvrez-le et choisissez un nouveau mot de passe.",
errorEmailRequired: "Veuillez saisir votre e-mail.",
errorSendFailed: "Le lien n’a pas été envoyé. Attendez une minute, puis réessayez.",
},
reset: {
  subtitleDoneApp: "Votre mot de passe est modifié. Touchez Se connecter et utilisez-le.",
  sendNewLink: "Envoyer un nouveau lien",
  titleExpired: "Ce lien a expiré",
title: "Définir un nouveau mot de passe",
titleDone: "Mot de passe mis à jour",
subtitle: "Choisissez un nouveau mot de passe pour votre compte.",
subtitleNoSession: "Les liens de réinitialisation ne servent qu’une fois et expirent au bout d’une heure. Touchez Envoyer un nouveau lien et nous vous en enverrons un autre.",
subtitleForm: "Saisissez deux fois votre nouveau mot de passe, puis touchez Mettre à jour le mot de passe.",
subtitleDone: "Votre mot de passe est modifié. Retournez dans l’application AssetWRX et connectez-vous avec.",
newPassword: "Nouveau mot de passe",
confirmNewPassword: "Confirmer le nouveau mot de passe",
confirmPassword: "Confirmer le mot de passe",
passwordPlaceholder: "Choisissez un mot de passe robuste",
confirmPlaceholder: "Saisir à nouveau le mot de passe",
submit: "Mettre à jour le mot de passe",
updating: "Mise à jour...",
loading: "Chargement...",
success: "Mot de passe mis à jour. Vous pouvez vous connecter.",
goToSignIn: "Se connecter",
backToSignIn: "Retour à la connexion",
errorTooShort: "Votre nouveau mot de passe est trop court. Utilisez au moins {{n}} caractères.",
errorPasswordRequired: "Veuillez saisir un nouveau mot de passe.",
errorMismatch: "Les mots de passe ne correspondent pas.",
errorUpdateFailed: "Impossible de mettre à jour le mot de passe.",
errorResetFailed: "Échec de la réinitialisation du mot de passe.",
errorInvalidSession: "Ce lien est invalide ou expiré. Demandez-en un nouveau depuis la page de connexion.",
},
reconsent: {
  firstBody: "Lisez les Conditions d’utilisation et la Politique de confidentialité, cochez les deux cases, puis touchez Accepter et continuer.",
  firstTitle: "Acceptez les conditions pour continuer",
errorMustAcceptBoth: "Les deux documents doivent être acceptés pour continuer.",
errorMustAcceptOne: "Le document doit être accepté pour continuer.",
errorSessionExpired: "Votre session a expiré. Veuillez choisir « Refuser et se déconnecter », puis vous reconnecter pour continuer.",
errorCouldNotRecord: "Impossible d'enregistrer votre acceptation. Vérifiez votre connexion et réessayez.",
unavailableTitle: "Impossible de vérifier votre acceptation enregistrée",
unavailableBody: "Rétablissez la connexion Internet et réessayez pour vérifier si des documents nécessitent votre examen. Votre travail enregistré reste sur cet appareil.",
tryAgain: "Réessayer",
continueOffline: "Continuer hors ligne pour le moment",
signOut: "Se déconnecter",
needsConsentTitle: "Les conditions mises à jour nécessitent votre acceptation",
needsConsentBody: "Nous avons mis à jour les documents ci-dessous. Veuillez lire et accepter les deux pour continuer à utiliser AssetWRX. Si vous choisissez de ne pas accepter, vous serez déconnecté – vous pourrez toujours demander la suppression de votre compte ou exporter vos données plus tard.",
needsConsentBodyOne: "Nous avons mis à jour le document ci-dessous. Veuillez le lire et l'accepter pour continuer à utiliser AssetWRX. Si vous choisissez de ne pas accepter, vous serez déconnecté – vous pourrez toujours demander la suppression de votre compte ou exporter vos données plus tard.",
acceptTermsA11y: "J'accepte les conditions d'utilisation (v{{version}})",
acceptTermsLabel: "J'accepte les conditions d'utilisation (v{{version}}).",
readTermsA11y: "Lire les conditions d'utilisation",
readTerms: "Lire les conditions d'utilisation",
acceptPrivacyA11y: "J'accepte la politique de confidentialité (v{{version}})",
acceptPrivacyLabel: "J'accepte la politique de confidentialité (v{{version}}).",
readPrivacyA11y: "Lire la politique de confidentialité",
readPrivacy: "Lire la politique de confidentialité",
recording: "Enregistrement",
recordingEllipsis: "Enregistrement…",
acceptAndContinue: "Accepter et continuer",
declineAndSignOut: "Refuser et se déconnecter",
},
guidedHub: {
  groupRule: {
    title: "Inspecter tout un groupe d’actifs selon un même calendrier",
    subtitle: "Configurez une règle de groupe, par exemple chaque porte coupe-feu chaque mois.",
  },
  assistantActivity: {
    title: "Choisir qui modifie via l'assistant",
    subtitle: "Activez ou coupez les changements via l'assistant pour les membres.",
  },
  requestFeature: {
    title: "Demander une fonctionnalité",
    subtitle: "Dites à l'équipe AssetWRX ce que l'app devrait faire ensuite.",
  },
  assetToursHint: "D’autres visites guidées sont sur chaque actif : ouvrez-le, touchez +, puis Guidez-moi.",
  guide: {
    subtitle: "Une aide pas à pas pour chaque partie de l’application.",
    title: "Lire le guide",
  },
  invite: {
    subtitle: "Ils reçoivent un e-mail et rejoignent votre équipe.",
    title: "Inviter un collègue",
  },
title: "Que voulez-vous faire ?",
subtitle: "Choisissez une tâche. Nous surlignons chaque élément à toucher, étape par étape.",
close: "Fermer",
groups: {
setup: "Configurez votre espace de travail",
reactive: "Partager",
proactive: "Planifier le travail",
workspace: "Gérer votre espace",
},
building: {
title: "Créer un bâtiment",
subtitle: "Un bâtiment, puis ses étages et ses pièces.",
},
asset: {
title: "Ajouter un actif",
subtitle: "Un bâtiment, un véhicule, une machine ou tout ce que vous gérez.",
},
site: {
title: "Ajouter un site",
subtitle: "Un lieu, comme un bâtiment ou un dépôt, qui regroupe des actifs.",
},
contractor: {
title: "Ajouter un prestataire",
subtitle: "Une personne ou une entreprise à qui vous confiez du travail.",
},
team: {
title: "Créer une équipe",
subtitle: "Partagez actifs et travail avec vos collègues.",
},
requesters: {
title: "Partager un actif",
subtitle: "Permettez à quelqu’un de voir un actif ou d’y demander du travail.",
},
inspection: {
title: "Planifier une inspection",
subtitle: "Une visite, ou une visite qui se répète.",
},
job: {
title: "Créer une intervention",
subtitle: "Une réparation ou une tâche, et qui la fait.",
},
maintenancePlan: {
title: "Mettre en place un plan de maintenance",
subtitle: "Un travail qui revient, comme un entretien annuel.",
},
compliance: {
title: "Vérifier certificats et conformité",
subtitle: "Voyez ce qui manque ou arrive à échéance, et corrigez-le.",
},
industryPack: {
title: "Ajouter des check-lists prêtes",
subtitle: "Des check-lists faites pour votre métier.",
},
transferOwnership: {
title: "Confier l’équipe à un nouveau propriétaire",
subtitle: "Rien ne change tant qu’il n’a pas accepté l’offre.",
},
},
guidedJourney: {
  esg: {
    figures: {
      title: "Les chiffres clés",
      body: "Chaque chiffre des 12 derniers mois avec son évolution sur l’année précédente, à partir des relevés que vous faites déjà. En dessous, le graphique et d’où vient le carbone.",
    },
    refrigerant: {
      title: "Fluide frigorigène et gaz fluorés",
      body: "Le gaz vient des détails de l’équipement. Saisissez la charge ; l’application calcule les tonnes de CO2e, la fréquence du contrôle d’étanchéité et le planifie. Le journal des fuites liste chaque contrôle, fuite et recharge.",
    },
    certificates: {
      title: "Diagnostics énergétiques",
      body: "Les certificats sont classés une seule fois, dans Documents. Ajoutez-y l’EPC ou le DEC et l’IA lit la classe et les dates ; cette carte l’affiche avec Ouvrir le certificat et Modifier.",
    },
    writeup: {
      title: "Faire rédiger",
      body: "Choisissez le lecteur et l’IA rédige un court résumé qui n’utilise que ces chiffres, avec des boutons pour créer le travail proposé.",
      },
    },
  subJobs: {
    card: {
      title: "Les parties de ce travail",
      body: "Chaque sous-travail a sa propre personne ou entreprise, sa date, ses contrôles et ses photos. Vous vérifiez chacun ; le travail entier est validé une seule fois.",
    },
    add: {
      title: "Touchez Ajouter un sous-travail",
      body: "La première fois, indiquez qui pilote le travail. Puis donnez un titre à la partie, qui la fait et quand. Ajoutez-en plusieurs à la suite avec Ajouter et suivant.",
    },
  },
  visits: {
    add: {
      title: "Planifier une autre visite",
      body: "Choisissez le jour et l'heure. Le travail apparaît dans Travail et dans le calendrier chaque jour de visite, et se termine une seule fois, à la fin.",
    },
  },
  groupRule: {
    add: {
      title: "Touchez Ajouter une règle de groupe",
      body: "Une règle de groupe applique une liste de contrôle à chaque actif d’un groupe, selon un même calendrier.",
    },
    which: {
      title: "Indiquez quels actifs",
      body: "Choisissez une catégorie : Lieu, Équipement, Véhicule ou Autre. Puis limitez-la à un type de lieu ou à un de vos types d’actif, comme Porte coupe-feu.",
    },
    where: {
      title: "Indiquez où",
      body: "Laissez Partout, ou choisissez un lieu comme le bâtiment A pour ne prendre que ce qu’il contient. Une zone affine encore.",
    },
    checklist: {
      title: "Choisissez la liste de contrôle",
      body: "Chaque inspection créée par la règle utilise cette liste de contrôle.",
    },
    howOften: {
      title: "Fréquence et date de début",
      body: "Choisissez la fréquence et la date de la première inspection. La suivante de chaque actif est planifiée une fois la précédente terminée.",
    },
    summary: {
      title: "Vérifiez la phrase",
      body: "La règle est résumée en une phrase, avec le nombre d’inspections créées à l’enregistrement.",
    },
    save: {
      title: "Enregistrez la règle",
      body: "Touchez Enregistrer la règle. Les inspections apparaissent sur la page Travail, et les actifs qui rejoignent le groupe plus tard reçoivent la leur.",
    },
  },
  assistantActivity: {
    policy: {
      title: "Choisissez qui peut faire des changements",
      body: "Propriétaires et admins choisissent : tout le monde, seulement les admins, ou personne. Avec personne, l'assistant répond et conseille sans rien changer.",
    },
    briefing: {
      title: "Votre point hebdomadaire",
      body: "Activez ou désactivez le point hebdomadaire en haut de l’assistant, et réactivez les questions suggérées. C’est votre propre réglage.",
    },
    memory: {
      title: "Ce que retient l’assistant",
      body: "Des préférences pour tout l’espace de travail que l’assistant suit, comme la façon dont vous nommez les choses ou qui reçoit d’habitude un type d’intervention. Ajoutez-les, modifiez-les ou oubliez-les ici.",
    },
    list: {
      title: "Chaque changement est listé ici",
      body: "Ce qui a changé, par qui et quand, et si c'était annulé. Les membres voient les leurs.",
    },
  },
  requestFeature: {
    open: {
      title: "Touchez Demander une fonctionnalité",
      body: "C'est dans Aide, sous le Guide utilisateur.",
    },
    what: {
      title: "Dites ce que vous voulez",
      body: "Un titre court, puis en quoi cela vous aiderait. N'y mettez pas de données personnelles ou de clients.",
    },
    area: {
      title: "Choisissez la partie de l'app",
      body: "Indiquez de quoi il s'agit et son importance, et ajoutez des captures d'écran si elles aident.",
    },
    send: {
      title: "Envoyez-la",
      body: "Touchez Envoyer la demande. Elle part à l'équipe AssetWRX, et Vos demandes affiche son statut et les réponses.",
    },
  },
  inMoreMenu: "Touchez Plus pour le trouver.",
  myDay: {
    startNext: {
      body: "Touchez Commencer la suivante pour ouvrir l’intervention et la démarrer.",
      title: "Commencez la visite suivante",
    },
    share: {
      body: "Touchez Partager la position pour que votre planificateur voie un retard. Ou touchez Suivant.",
      title: "Partager votre position (facultatif)",
    },
    agenda: {
      body: "Vos visites du jour, dans l’ordre, avec le trajet entre elles. Touchez Suivant.",
      title: "Voici votre journée",
    },
  },
  inPlusMenu: "Touchez + pour le trouver.",
next: "Suivant",
skipStep: "Passer cette étape",
skip: "Arrêter la visite",
share: {
  confirm: {
    body: "Choisissez Peut consulter ou Peut demander du travail, puis touchez Partager. Les personnes sans compte reçoivent une invitation.",
    title: "Choisissez ce qu’ils peuvent faire",
  },
assetOpen: {
title: "Ouvrez l’actif",
body: "Touchez l’actif à partager.",
},
shareAction: {
title: "Partager avec une personne",
body: "Touchez Partager avec une personne ou une équipe. Elle n’aura accès qu’à cet actif.",
},
createContact: {
title: "Choisissez la personne",
body: "Touchez un contact, ou Créer et lier un contact pour ajouter quelqu’un. Puis touchez Continuer.",
},
},
inspection: {
pickAsset: {
title: "Choisissez l’actif",
body: "Touchez l’actif à inspecter.",
},
createChecklist: {
title: "Choisissez la check-list",
body: "Gardez cette check-list et touchez Suivant, ou touchez Changer pour en choisir une. Aucune ? Touchez Créer une check-list.",
},
when: {
title: "Choisissez quand",
body: "Touchez Maintenant pour commencer tout de suite, ou Plus tard pour choisir une date et une heure.",
},
submit: {
title: "Lancez-la",
body: "Touchez Démarrer l’inspection (ou Planifier si vous avez choisi Plus tard). Répondez à chaque point, puis touchez Terminer l’inspection.",
},
},
job: {
pickAsset: {
title: "Choisissez l’actif",
body: "Touchez l’actif concerné par le travail.",
},
title: {
title: "Dites ce qu’il faut faire",
body: "Saisissez un titre court, comme Remplacer la courroie, puis choisissez qui le fait.",
},
submit: {
title: "Créez l’intervention",
body: "Touchez Créer l’intervention (ou Planifier si vous avez choisi Plus tard). La personne choisie est prévenue et doit accepter.",
},
},
proactive: {
when: {
title: "Touchez Plus tard",
body: "Puis choisissez le jour et l’heure du premier contrôle.",
},
recurrence: {
title: "Choisissez la fréquence",
body: "Sous Répéter, touchez la fréquence, comme Tous les mois.",
},
submit: {
title: "Planifiez",
body: "Touchez Planifier l’inspection. Chaque contrôle apparaît dans Travail le jour venu ; touchez Ouvrir dans le message.",
},
},
addSite: {
name: {
title: "Nommez le site",
body: "Saisissez le nom utilisé par votre équipe, comme Dépôt Nord.",
},
location: {
title: "Adresse (facultatif)",
body: "Saisissez l’adresse et choisissez-la dans la liste. Ou touchez Suivant pour passer.",
},
classify: {
title: "Type de site (facultatif)",
body: "Choisissez le type de lieu et son statut. Ou touchez Suivant pour passer.",
},
structure: {
title: "Site parent et équipe (facultatif)",
body: "Placez-le dans un site plus grand ou choisissez l’équipe responsable. Ou touchez Suivant.",
},
create: {
title: "Créez le site",
body: "Touchez Créer le site. Le site s’ouvre, prêt pour ses actifs.",
},
},
addAssetsToSite: {
assign: {
title: "Ajoutez des actifs à ce site",
body: "Touchez Affecter et choisissez l’actif à déplacer ici. Un message confirme le déplacement.",
},
},
addContractor: {
name: {
title: "Saisissez son nom",
body: "Saisissez le nom de la personne ou de l’entreprise.",
},
contact: {
title: "Saisissez son e-mail",
body: "Un prestataire doit avoir un e-mail : les invitations aux interventions et aux devis y sont envoyées.",
},
save: {
title: "Ajoutez le prestataire",
body: "Touchez Ajouter le contact. Pour leur confier du travail, ouvrez une intervention et touchez Affecter.",
},
},
raiseRequest: {
  summary: {
    body: "Saisissez un résumé court, comme Fuite au robinet de la cuisine.",
    title: "Dites ce qui ne va pas",
  },
outcome: {
title: "De quoi avez-vous besoin ?",
body: "Choisissez : Juste de l’aide, Une intervention, ou Une inspection.",
},
submit: {
title: "Envoyez",
body: "Touchez Envoyer. Une intervention ou inspection s’ouvre déjà remplie ; sinon la demande attend dans Travail.",
},
},
shareReport: {
contact: {
title: "Choisissez le destinataire",
body: "Touchez Choisir un contact et sélectionnez la personne.",
},
role: {
title: "Vérifiez qui c’est",
body: "Sa relation est reprise du contact. Touchez Modifier seulement si elle est fausse, ou Suivant.",
},
send: {
title: "Envoyez",
body: "Touchez Envoyer le rapport. Ils reçoivent un e-mail avec un lien, et vous êtes prévenu de leur réponse.",
},
},
planADay: {
  apply: {
    body: "Rien n’est enregistré avant Appliquer. Chacun doit ensuite accepter sa journée.",
    title: "Touchez Appliquer pour enregistrer",
  },
  optimise: {
    body: "Touchez Proposer un plan pour remplir la journée avec le moins de trajets. Touchez × sur ce que vous ne voulez pas.",
    title: "Ou laissez l’app proposer",
  },
  panel: {
    body: "Choisissez la personne, le jour et l’heure. C’est en pointillés jusqu’à Appliquer.",
    title: "Choisissez qui et quand",
  },
  unplanned: {
    body: "Cette liste montre le travail sans horaire ou sans personne. Touchez-en un pour le planifier.",
    title: "Commencez par Non planifié",
  },
  },
convertRequest: {
approve: {
title: "Approuvez la demande",
body: "Touchez Approuver, puis encore Approuver pour confirmer. Le demandeur est prévenu.",
},
convert: {
title: "Transformez-la en travail",
body: "Touchez Créer une intervention ou Inspecter. Les détails sont remplis ; vous choisissez qui et quand.",
},
},
addDocument: {
  title: {
    body: "Saisissez un nom clair, comme Certificat gaz 2026.",
    title: "Donnez-lui un titre",
  },
type: {
title: "Choisissez le type de document",
body: "Sous Type de document, choisissez Certificat, Garantie, Conformité ou Général.",
},
save: {
title: "Ajoutez le fichier et enregistrez",
body: "Joignez le fichier, ajoutez la date d’expiration s’il y en a une, puis touchez Enregistrer le document.",
},
},
assignAssetTeam: {
change: {
title: "Touchez Modifier",
body: "À côté d’Équipe responsable, touchez Modifier.",
},
pick: {
title: "Choisissez l’équipe",
body: "Touchez l’équipe. Un message confirme qui peut maintenant le voir.",
},
},
addTeam: {
open: {
title: "Touchez Créer une équipe",
body: "Une équipe partage actifs et travail avec les personnes invitées. Vous en avez déjà une ? Touchez Nouvelle équipe.",
},
name: {
title: "Nommez l’équipe",
body: "Choisissez un nom que vos collègues reconnaîtront.",
},
submit: {
title: "Créez-la",
body: "Touchez Créer une équipe. La zone d’invitation s’ouvre ensuite.",
},
},
inviteMembers: {
open: {
title: "Touchez Inviter",
body: "Invitez un collègue dans cette équipe.",
},
email: {
title: "Saisissez son e-mail",
body: "Saisissez son adresse e-mail, une par ligne, et choisissez Membre ou Admin.",
},
send: {
title: "Envoyez l’invitation",
body: "Touchez Envoyer l’invitation. La personne reçoit un e-mail et apparaît dans Membres après acceptation.",
},
},
assignContractor: {
open: {
title: "Touchez Affecter",
body: "Choisissez le collègue ou prestataire. Un prestataire doit avoir un e-mail pour être prévenu.",
},
},
aiReport: {
reader: {
title: "Pour qui est-il ?",
body: "Choisissez le lecteur. Les mêmes faits sont présentés dans l’ordre qui compte pour lui. Ou touchez Suivant.",
},
analyses: {
title: "Choisissez les sujets",
body: "Tous les sujets sont cochés. Touchez-en un pour l’exclure, ou touchez Suivant.",
},
generate: {
title: "Créez le rapport",
body: "Vérifiez le coût, puis touchez Rédiger la version IA. Vous êtes prévenu quand il est prêt, et les crédits ne sont utilisés qu’à ce moment-là.",
},
},
relateAsset: {
search: {
title: "Trouvez l’autre actif",
body: "Cherchez l’autre actif et touchez-le.",
},
save: {
title: "Enregistrez le lien",
body: "Choisissez le type de lien et touchez Ajouter la relation.",
},
},
publicIntake: {
share: {
title: "Touchez Partager",
body: "Le signalement par QR code se règle depuis Partager.",
},
choose: {
title: "Laisser tout le monde signaler",
body: "Touchez Laisser toute personne ayant le code signaler un problème. Aucun compte n’est nécessaire.",
},
enable: {
title: "Activez-le",
body: "Activez l’interrupteur. Le code et le lien apparaissent en dessous.",
},
copy: {
title: "Partagez le lien",
body: "Touchez Copier le lien (ou Imprimer le QR sur ordinateur) et placez-le bien en vue.",
},
},
setUpBuilding: {
name: {
title: "Nommez le bâtiment",
body: "Saisissez le nom utilisé, par exemple Bâtiment A ou Tour Nord.",
},
type: {
title: "C’est un lieu",
body: "Lieu est déjà choisi. Les étages, pièces, parkings et autres zones sont aussi des lieux.",
},
placeType: {
title: "Touchez Bâtiment",
body: "Indiquez quel type de lieu c’est. Choisissez Bâtiment ici ; ensuite Étage ou Pièce pour ce qu’il contient.",
},
save: {
title: "Créez-le",
body: "Touchez Créer l’actif. Le bâtiment s’ouvre ensuite.",
},
addInside: {
title: "Ajoutez ses étages",
body: "Touchez Ajouter un lieu dedans pour créer l’Étage 1. Chaque étage a le même bouton pour ses pièces, et Ajouter un équipement ici pour ce qui y est installé.",
},
},
addAsset: {
name: {
title: "Nommez-le",
body: "Saisissez le nom utilisé par votre équipe, comme Chaudière 3 ou 14 rue des Chênes.",
},
type: {
title: "Choisissez le type",
body: "Touchez Lieu, Équipement, Véhicule ou Autre. Un lieu est un bâtiment, un étage, une pièce ou toute autre zone. Si « Ressemble à » apparaît, touchez Utiliser.",
},
location: {
title: "Où est-il ? (facultatif)",
body: "Ajoutez le site ou l’adresse pour qu’on le trouve. Ou touchez Suivant pour passer.",
},
identify: {
title: "Photo et numéro (facultatif)",
body: "Ajoutez une photo et le numéro de sa plaque pour le retrouver sur place. Ou touchez Suivant.",
},
details: {
title: "Plus de détails (facultatif)",
body: "Ajoutez marque, check-list et dates clés maintenant ou plus tard. Ou touchez Suivant.",
},
save: {
title: "Créez-le",
body: "Touchez Créer l’actif. Il s’ouvre ensuite, prêt à être inspecté.",
},
},
decommission: {
options: {
title: "Ouvrez le menu ⋯",
body: "Touchez ⋯ en haut de l’actif.",
},
status: {
  title: "Touchez Changer le statut",
  body: "Mise en service, mise hors service, retrait et restauration se trouvent ici.",
},
choose: {
title: "Touchez Mettre hors service",
body: "L’actif garde son historique. Le travail courant s’arrête jusqu’à sa remise en service.",
},
reason: {
title: "Choisissez une raison",
body: "Choisissez pourquoi il sort du service. C’est enregistré dans l’historique.",
},
confirm: {
title: "Confirmez",
body: "Touchez Créer l’intervention de mise en sécurité, ou désactivez-la et touchez Mettre hors service maintenant.",
},
},
commission: {
start: {
title: "Touchez Mettre en service",
body: "Sur la bannière, touchez Mettre en service.",
},
inspect: {
title: "Lancez l’inspection",
body: "Touchez Démarrer l’inspection. Une fois terminée avec ses interventions, touchez Remettre en service.",
},
},
retire: {
options: {
title: "Ouvrez le menu ⋯",
body: "Touchez ⋯ en haut de l’actif.",
},
status: {
  title: "Touchez Changer le statut",
  body: "Mise en service, mise hors service, retrait et restauration se trouvent ici.",
},
choose: {
title: "Touchez Retirer définitivement l’actif",
body: "Seul un actif hors service peut être retiré définitivement. Sinon, on vous propose d’abord la mise hors service.",
},
reason: {
title: "Indiquez pourquoi",
body: "Choisissez la raison. S’il a été vendu ou mis au rebut, indiquez à qui.",
},
confirm: {
title: "Tapez RETIRER pour confirmer",
body: "Tapez RETIRER, puis touchez Retirer définitivement cet actif. Un propriétaire ou admin peut le rétablir.",
},
},
meterReading: {
value: {
title: "Saisissez le relevé",
body: "Saisissez le chiffre du compteur. Sur téléphone, ajoutez plutôt une photo et l’app le lit.",
},
save: {
title: "Enregistrez",
body: "Touchez Enregistrer le relevé. Les plans au kilométrage ou aux heures partent de ce chiffre.",
},
},
maintenancePlan: {
  asset: {
    body: "Touchez Actif et choisissez ce que concerne ce plan. Déjà choisi ? Touchez Suivant.",
    title: "Choisissez l’actif",
  },
title: {
title: "Dites ce qui est fait",
body: "Sous Ce qui est fait, saisissez le travail, comme Entretien annuel.",
},
cadence: {
title: "Choisissez la fréquence",
body: "Sous Quand est-ce dû ?, gardez Se répète et réglez Tous les 12 mois, ou activez Répéter au compteur. Puis Suivant.",
},
save: {
title: "Créez le plan",
body: "Choisissez Intervention ou Inspection sous Faire comme, puis touchez Créer le plan. Un message indique quand la première apparaît dans Travail.",
},
},
addKnowledge: {
kind: {
title: "Choisissez quoi ajouter",
body: "Choisissez une note, une FAQ, un mode d’emploi, un lien ou un fichier.",
},
title: {
title: "Donnez un titre",
body: "Utilisez des mots qu’on chercherait, comme Réarmer la chaudière. Puis écrivez ou dictez.",
},
save: {
title: "Enregistrez",
body: "Touchez Enregistrer. Toute personne travaillant sur cet actif le trouvera.",
},
},
moveAsset: {
reason: {
title: "Déplacé ou correction ?",
body: "Touchez Il a été déplacé ou C’était faux.",
},
location: {
title: "Où est-il maintenant ?",
body: "Cherchez l’adresse ou utilisez votre position actuelle.",
},
submit: {
title: "Enregistrez le déplacement",
body: "Touchez Enregistrer le déplacement, ou Corriger l’emplacement. L’ancien lieu reste dans l’historique.",
},
},
complianceRegister: {
refine: {
title: "Trouvez ce qu’il vous faut (facultatif)",
body: "Cherchez par nom ou touchez Affiner pour filtrer. Puis touchez Suivant.",
},
row: {
title: "Corrigez une ligne",
body: "Chaque ligne indique ce qui manque ou arrive à échéance. Touchez son bouton, comme Renouveler.",
},
},
industryPack: {
install: {
title: "Installez un pack",
body: "Touchez Installer le pack de votre métier. Ses check-lists apparaissent dans Check-lists.",
},
},
transferOwnership: {
open: {
title: "Touchez Transférer la propriété",
body: "C’est dans Paramètres de l’équipe. Seul le propriétaire le voit, dès qu’il y a un autre membre.",
},
member: {
title: "Choisissez le nouveau propriétaire",
body: "Choisissez un membre. Rien ne change avant son accord ; vous devenez alors admin.",
},
},
},
mfa: {
  codeNotValid: "Ce code n’a pas fonctionné. Les codes changent toutes les 30 secondes : ouvrez votre application d’authentification et saisissez le plus récent.",
invalidCode: "Ce code n’est pas valide. Vérifiez votre application d’authentification et réessayez.",
enterCode: "Saisissez le code à 6 chiffres",
verifying: "Vérification en cours…",
verifyCta: "Vérifier et activer",
challenge: {
  contactSupport: "Contacter l'assistance AssetWRX",
pageTitle: "Vérification en deux étapes",
title: "Saisissez votre code de vérification",
body: "Ouvrez votre application d’authentification et saisissez le code à 6 chiffres pour AssetWRX.",
backA11y: "Annuler la connexion et revenir en arrière",
back: "Retour",
loadError: "Impossible de charger votre méthode de vérification en deux étapes. Reconnectez-vous.",
resetSent_one: "Nous avons prévenu l’administrateur de votre espace de travail. Il peut réinitialiser votre vérification en deux étapes pour que vous la configuriez à nouveau.",
resetSent_other: "Nous avons prévenu les administrateurs de votre espace de travail. Ils peuvent réinitialiser votre vérification en deux étapes pour que vous la configuriez à nouveau.",
resetNoAdmin: "Vous êtes le propriétaire de l'espace de travail : personne au-dessus de vous ne peut réinitialiser cela. Connectez-vous sur un appareil qui a encore votre application d'authentification, ou contactez l'assistance AssetWRX ci-dessous.",
resetError: "Impossible d’envoyer la demande. Veuillez réessayer.",
verifyCta: "Vérifier",
lostDevice: "Appareil perdu ? Demandez à un administrateur de l’espace de travail de réinitialiser votre vérification en deux étapes, ou déconnectez-vous.",
requestReset: "Demander une réinitialisation à votre administrateur",
requesting: "Envoi…",
signOut: "Se déconnecter",
resetSent_many: "Nous avons prévenu les administrateurs de votre espace de travail. Ils peuvent réinitialiser votre vérification en deux étapes pour que vous la configuriez à nouveau.",
},
enroll: {
  otherPhoneQr: "Vous utilisez un autre téléphone ? Scannez ce code.",
  step2SameDevice: "Touchez Ouvrir l’application d’authentification, ajoutez le compte, puis revenez ici",
  a11yGooglePlay: "{{app}} : disponible sur Google Play",
  a11yAppStore: "{{app}} : télécharger sur l’App Store",
  appBlurb: "Gratuit. Fonctionne sur iPhone et Android.",
backA11y: "Retour",
back: "Retour",
title: "Configurer la connexion en deux étapes",
lead: "Cela ajoute une seconde étape à la connexion pour que vous seul puissiez entrer — même si quelqu’un découvre votre mot de passe. Cela prend environ une minute.",
startError: "Impossible de démarrer la configuration. Veuillez réessayer.",
step1: "Installez une application d’authentification gratuite sur votre téléphone",
step1Hint: "Vous en avez déjà une ? Passez à l’étape 2.",
appStore: "iPhone",
googlePlay: "Android",
step2: "Dans l’application, touchez « ＋ » et scannez ce code",
qrAlt: "QR code de vérification en deux étapes",
manualLabel: "Impossible de scanner ? Saisissez cette clé manuellement :",
copySecret: "Copier la clé de configuration",
openApp: "Ouvrir l’application d’authentification",
step3: "Saisissez le code à 6 chiffres affiché par l’application",
preparing: "Préparation de votre configuration…",
backupTitle: "Ajoutez une sauvegarde, au cas où",
backupBody: "La vérification en deux étapes est activée. Si vous perdez votre application d’authentification, une seconde sur un autre appareil est le moyen le plus rapide de retrouver l’accès. Recommandé.",
addBackup: "Ajouter un authentificateur de sauvegarde",
finish: "Terminer",
backupSetupTitle: "Ajoutez votre application d’authentification de secours",
backupSetupBody: "Scannez ceci avec votre seconde application d’authentification, puis saisissez le code à 6 chiffres qu’elle affiche.",
skipBackup: "Passer pour l’instant",
},
gate: {
challengeTitle: "Confirmez que c’est bien vous",
blockedTitle: "La connexion en deux étapes est obligatoire",
nagTitle: "Activez la connexion en deux étapes",
challengeBody: "Saisissez le code de votre application d’authentification pour continuer.",
blockedBody: "Pour protéger votre compte, configurez une application d’authentification pour continuer.",
nagBody: "Ajoutez une application d’authentification pour renforcer nettement la sécurité — cela ne prend qu’une minute.",
nagBodyDated: "La connexion en deux étapes devient obligatoire le {{dateLabel}}. Configurez-la maintenant — cela ne prend qu’une minute.",
verifyCta: "Entrez le code",
setupCta: "Configurer la vérification en deux étapes",
signOut: "Se déconnecter",
later: "Me le rappeler plus tard",
},
},
};
